(function () {
    'use strict';

    angular.module("imApp").factory("carrierListService", [function () {
        let service = {};

        return service;
    }]);
})();
